import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  destroyPackageGroup: ({ packing_house_process_id, container_id, package_group_id }) => {
    return RequesterV1.delete(
      `/packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/container/${container_id}/destroy_package_group/${package_group_id}`
    );
  },
  container({ packing_house_process_id, container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/container/${container_id}`
    );
  },
  fetchPackingHouseProcesses(packing_house_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/list_processes/" + packing_house_id
    );
  },
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/list_containers/fetch_packing_house_process/" + packing_house_process_id
    );
  },
  fetchContainers({ packing_house_process_id, current_page, rows_per_page }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/list_containers/${packing_house_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`
    );
  },
  fetchPackagesFromStock({ packing_house_process_id, current_page, rows_per_page }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/list_containers/fetch_packages_from_stock/${packing_house_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`
      
    );
  },
  fetchPackageGroup({ packing_house_process_id, container_id, package_group_id }) {
    return RequesterV1.get(
      `/packing_house/production/uniq_final_packing_list/edit_package_group/${packing_house_process_id}/container/${container_id}/package_group/${package_group_id}`
    );
  },
  fetchCropSizes(packing_house_process_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/list_exporter_process_crop_sizes/${agro_exporter_process_id}`
    );
  },
  fetchPackingListFormats(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/fetch_packing_list_formats/${container_id}`
    );
  },
  downloadPackingListXlsx(packing_house_process_id, container_id, packing_list_format_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/${packing_house_process_id}/download_packing_list_xlsx/${container_id}/${packing_list_format_id}`,
      { responseType: "blob" }
    );
  }
};
